import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'
import {matchPath, useLocation} from 'react-router-dom'

import {
  InnerSideNav,
  InnerSideNavItem,
} from '~/components/layout/sideNavs/innerSideNav/InnerSideNav'

type ServicesSidebarNavProps = {
  fullPath: string
  onClick: (id: string) => void
}

export const ServicesSidebarNav: React.FC<ServicesSidebarNavProps> = ({
  fullPath,
  onClick,
}) => {
  const {t} = useTranslation<string>()
  const location = useLocation()

  const navDataList = useMemo(
    () => [
      {id: 'services', label: t('Services')},
      {id: 'staff-assignment', label: t('Staff assignment')},
    ],
    [t],
  )

  const activeRouteId = useMemo(
    () =>
      navDataList
        .map(({id}) => matchPath(`${fullPath}${id}`, location.pathname) && id)
        .find((result) => !!result) || navDataList[0].id,
    [navDataList, fullPath, location.pathname],
  )

  return (
    <InnerSideNav>
      {navDataList.map((data) => (
        <InnerSideNavItem
          key={data.id}
          active={activeRouteId === data.id}
          onClick={() => onClick(data.id)}>
          {data.label}
        </InnerSideNavItem>
      ))}
    </InnerSideNav>
  )
}
